export const CALENDLY_URL = "https://calendly.com/freedombyaidesign";
export const FOUNDER_IMG = "https://customer-assets.emergentagent.com/job_creative-freedom-ai-1/artifacts/rv3qp0ej_ChatGPT%20Image%20Jun%2025%2C%202026%2C%2001_34_39%20PM.png";
